import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeFilterChip } from '../redux/actions'; // Adjust path as needed
import './FilterChipBar.css'; // Create this CSS file for styling

const FilterChipBar = () => {
  const filterChips = useSelector(state => state.keywords.filterChips);
  const dispatch = useDispatch();

  if (!filterChips || filterChips.length === 0) {
    return null; // Don't render anything if there are no active filters
  }

  return (
    <div className="filter-chip-bar">
      {filterChips.map(chip => (
        <div key={chip.id} className="filter-chip">
          <span className="filter-chip-label" title={chip.label}>{chip.label}</span>
          <button
            className="filter-chip-remove"
            onClick={() => dispatch(removeFilterChip(chip.id))}
            aria-label={`Remove filter: ${chip.label}`}
          >
            &times; {/* HTML entity for 'x' */}
          </button>
        </div>
      ))}
    </div>
  );
};

export default FilterChipBar;
